import { useQuery } from "react-query";
import { api } from "../constants";
import { AxiosInstance } from "../axios.config";

const getLearningList = async (searchParam: string) => {
  const response = await AxiosInstance.get(
    api.learning.list + "?query=" + searchParam
  );
  return response.data;
};
const useGetLearningList = (searchParam: string) => {
  return useQuery({
    queryKey: ["learningList", searchParam],
    queryFn: () => getLearningList(searchParam),
    refetchOnWindowFocus: false,
  });
};

export { useGetLearningList };
